module.exports = __webpack_public_path__ + "static/media/logoca.21b58c0a.png";